import React from "react";
import { NewContainer } from "../NewContainer";

const cards = [
  {
    icon: "⚡",
    title: "10x faster than manual processes",
    description:
      "Our AI processes thousands of transactions in minutes. What once took days of manual work is completed automatically.",
  },
  {
    icon: "🎯",
    title: "100% expert-verified",
    description:
      "Every reconciliation, report, and BAS is reviewed by CA or CPA to ensure accuracy and compliance.",
  },
  {
    icon: "💰",
    title: "Save up to 66%",
    description:
      "AI automation dramatically reduces the time and cost of bookkeeping, delivering accurate financials without the traditional overhead.",
  },
  {
    icon: "🧠",
    title: "AI that learns your business",
    description:
      "Our AI continuously learns from your transactions, chart of accounts, and patterns to improve accuracy over time.",
  },
  {
    icon: "📞",
    title: "Real people, real answers",
    description:
      "Your dedicated account manager picks up the phone, knows your business, and gives you straight answers.",
  },
  {
    icon: "🇦🇺",
    title: "Built for Australia",
    description:
      "ATO-compliant from day one. BAS, GST, PAYG, STP — our AI is trained on Australian tax law, and our team lives and breathes it.",
  },
];

const AdditionalServiceSection = () => {
  return (
    <section className="py-[120px] px-6 lg:px-10 bg-base-white">
      <div className="max-w-[1340px] mx-auto">
        <div className="mb-4 fade-in">
          <span className="inline-flex items-center gap-1.5 bg-blue-primary-500/[0.08] text-blue-primary-500 text-[13px] font-semibold px-4 py-1.5 rounded-full tracking-[0.5px]">
            Why <span className="font-bold">Ledgerowl</span>
          </span>
        </div>
        <h2 className="font-inter text-[36px] leading-[46px] font-extrabold tracking-[-1.5px] mb-4 fade-in">
          AI automation verified by experts.
        </h2>
        <p className="font-inter text-[18px] text-gray-cool-500 max-w-[640px] leading-[1.7] mb-[72px] fade-in">
          Ledgerowl combines the speed of AI in preparing the books with oversight from qualified CAs and CPAs — delivering accurate, reliable financials without the manual workload.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card) => {
            const isRealPeople = card.title.includes("Real people");
            return (
              <div
                key={card.title}
                className={`fade-in bg-blue-primary-50 border border-blue-primary-500/[0.08] rounded-[20px] p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,116,230,0.08)] ${
                  isRealPeople ? "md:col-span-2 lg:col-span-1" : ""
                }`}
              >
                <span className="text-[28px] block mb-5">{card.icon}</span>
                <h4 className="font-inter text-[20px] font-bold mb-3 text-gray-cool-900">
                  {card.title}
                </h4>
                <p className="font-inter text-[15px] leading-[1.7] text-gray-cool-500">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center fade-in">
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-blue-primary-500 hover:bg-[#005bb5] text-white px-9 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,116,230,0.35)]"
          >
            Book a Demo
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServiceSection;
